import React, {useMemo} from 'react';

import VariantModel from 'coreClasses/product/VariantModel';
import PromotionModel from 'coreClasses/promotion/PromotionModel';
import DangerousHTML from 'coreComponents/DangerousHtml/DangerousHTML';

import {usePromotionsMgr} from 'brandHooks';

import {ICalloutMessagesProps} from './ICalloutMessagesPlp';

const CalloutMessagesPlp = ({product}: ICalloutMessagesProps) => {
	const PromotionsMgr = usePromotionsMgr();

	const promotionIds = useMemo(() => {
		if (!product) {
			return [];
		}

		if (product instanceof VariantModel) {
			return product.getProductPromotions()?.map(el => el.promotionId);
		}

		return product?.getProductPromotions()?.map(el => el.getPromotionId());
	}, [product]);

	const promotions: PromotionModel[] = promotionIds ? PromotionsMgr.getPromotions(promotionIds) : [];

	return (promotions?.map(
		(promotion: PromotionModel) =>
			promotion.getCalloutMessagePLP() && (
				<DangerousHTML
					key={promotion.getPromotionId()}
					html={promotion.getCalloutMessagePLP()}
					classNames={'callout_msg'}
				/>
			),
	) as unknown) as React.ReactElement;
};

export default CalloutMessagesPlp;
